import { useContext } from "react";

import { SelectionValuesActions, SelectionValuesContextDispatch } from "helpers/context/SelectionValues/SelectionValuesContext";

export function useSelectionValuesActions(): SelectionValuesActions {
    return useContext(SelectionValuesContextDispatch)!;
};

export default useSelectionValuesActions;
